import {AppState} from "../app";
import {AnimationWrapMode} from "../engine/tools/Animation";
import {clamp, mod} from "../engine/utils/math";
import {SCENE_STATE, SceneStateManager} from "../components/state/sceneStateManager";
import {AnimationPlayer} from "../components/animation/animationPlayer";
import {ImageRenderer} from "../components/image/imageRenderer";



export function updateAnimationPlayer({interactiveCanvas, entities, time, soundEvents, animations}: AppState) {


    entities.forEach([AnimationPlayer, SceneStateManager], (e) => {

        const anim = e.SceneStateManager.animations[e.SceneStateManager.animationId]

        switch (e.SceneStateManager.currentState) {

            case SCENE_STATE.TRANSITION_IN:
                e.AnimationPlayer.animation = anim.transitionInAnimation
                break
            case SCENE_STATE.TRANSITION_OUT:
                e.AnimationPlayer.animation = anim.transitionOutAnimation
                break
            default:
                e.AnimationPlayer.animation = Array.isArray(anim.mainAnimation) ? anim.mainAnimation[e.SceneStateManager.animationSubId] : anim.mainAnimation
                break
        }
    })

    entities.forEach([AnimationPlayer], (e) => {

        const anim = animations[e.AnimationPlayer.animation]
        if (!anim) {
            e.AnimationPlayer.wasPlaying = false
            return
        }

        if(e.AnimationPlayer.isPlaying && !e.AnimationPlayer.wasPlaying)
        {
            e.AnimationPlayer.timeSinceLastFrame = 0
        }

        if(e.AnimationPlayer.isPlaying)
        {
            e.AnimationPlayer.timeSinceLastFrame += time.deltaTime

            const frameTime =  1 / anim.frameRate
            const framesPassed = Math.floor( e.AnimationPlayer.timeSinceLastFrame / frameTime)
            e.AnimationPlayer.currentFrameId += framesPassed
            e.AnimationPlayer.timeSinceLastFrame -= framesPassed * frameTime
        }
    })


    entities.forEach([AnimationPlayer], (e) => {

        const anim = animations[e.AnimationPlayer.animation]
        if (!anim)
            return

        let id = e.AnimationPlayer.currentFrameId


        switch (anim.wrapMode) {
            case AnimationWrapMode.Repeat:
                id = mod(id, anim.sprites.length)
                break
            case AnimationWrapMode.Clamp:
                id = clamp(id, 0, anim.sprites.length - 1)
                if(id >= anim.sprites.length - 1)
                    e.AnimationPlayer.isPlaying = false
                break
        }

    })

    entities.forEach([AnimationPlayer, ImageRenderer], (e) => {

        const anim = animations[e.AnimationPlayer.animation]
        if (!anim)
            return
        e.ImageRenderer.sprite = e.AnimationPlayer.currentFrameId != -1 ? anim.sprites[e.AnimationPlayer.currentFrameId] : undefined
    })

    entities.forEach([AnimationPlayer], (e) => {

        e.AnimationPlayer.wasPlaying = e.AnimationPlayer.isPlaying
    })

}
